<template>
    <div id="user-create__view">
        <user-form :form="form" :has-aad-license="checkAzureADLicence()" :handler="editUser" is-edit-mode></user-form>

        <sp-loader v-if="isLoading"></sp-loader>
    </div>
</template>

<script>
import UserForm from '@/views/Users/components/UserForm'
import AssignToOrganizationsAndFleets from '@/views/Users/components/AssignToOrganizationsAndFleets'
import SpLoader from '@/components/atoms/Loader'
import toast from '@/plugins/izitoast'
import UserApi from '@/api/UserApi'
import moment from 'moment'

const userApi = new UserApi()

export default {
    name: 'UserEdit',
    created () {
        this.id = this.$route.params.id
        if (!this.hasAllRoles(['UserView'])) return
        this.getUser()
    },
    components: {
        UserForm,
        AssignToOrganizationsAndFleets,
        SpLoader
    },
    data () {
        return {
            id: null,
            valid: false,
            isFormLoading: false,
            isAssignToOrgAndFleetsLoading: false,
            form: {
                userName: '',
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                azureAdId: '',
                permissions: null,
                organizationId: null,
                expiresIn: null,
                roles: null,
                accessForAllSubOrgs: true
            }
        }
    },
    computed: {
        isLoading () {
            return this.isFormLoading || this.isAssignToOrgAndFleetsLoading
        }
    },
    methods: {
        async editUser (form) {
            if (!this.hasAllRoles(['UserUpdate'])) return
            const {
                userName,
                firstName,
                lastName,
                phoneNumber,
                email,
                permissions,
                roles,
                expiresIn,
                organizationId,
                accessForAllSubOrgs,
                azureAdId
            } = form

            const response = await userApi.editUser({
                id: this.id,
                userName,
                firstName,
                lastName,
                phoneNumber,
                email,
                permissions,
                roles,
                expiresIn: expiresIn ? moment(expiresIn).format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z' : null,
                organizationId,
                accessForAllSubOrgs,
                ...(this.checkAzureADLicence() && azureAdId ? { azureAdId } : {})
            })

            if (!response.isSuccess) {
                return
            }

            toast.success('User successfully updated.')
        },
        async getUser () {
            this.isFormLoading = true
            const response = await userApi.getUser(this.id)

            this.form.userName = response.payload.userName
            this.form.firstName = response.payload.firstName
            this.form.lastName = response.payload.lastName
            this.form.email = response.payload.email
            this.form.phoneNumber = response.payload.phoneNumber
            this.form.fleets = response.payload.fleets
            this.form.permissions = response.payload.permissions
            this.form.organizationId = response.payload.organization.id
            this.form.expiresIn = response.payload.expiresIn ? moment(response.payload.expiresIn)._d : null
            this.form.roles = response.payload.roles ? response.payload.roles.map(role => role.id) : null
            this.form.accessForAllSubOrgs = response.payload.accessForAllSubOrgs
            if (this.checkAzureADLicence()) {
                this.form.azureAdId = response.payload.azureAdId
            }

            this.isFormLoading = false
        },
        onIsLoading (state) {
            this.isAssignToOrgAndFleetsLoading = state
        }
    }
}
</script>
